import React, { useEffect, useRef } from 'react';
import styles from './popup.module.css';
import { createPortal } from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import { Backdrop } from './Backdrop';
import { blockScrollBar } from '../../../utils/js/blockScrollBar';

export interface IPopupProps {
	children: React.ReactNode;
	bgStyle?: string;
	state: boolean;
	onClose: () => void;
	buttonRef?: React.MutableRefObject<HTMLButtonElement | null>;
}

export function Popup({children, buttonRef, bgStyle, state, onClose}: IPopupProps) {
	const popupRef = useRef<HTMLDivElement | null>(null);

	const classNames = {
		enter: styles.nodeEnter,
		enterActive: styles.nodeEnterActive,
		exit: styles.nodeExit,
		exitActive: styles.nodeExitActive,
	}

	useEffect(() => {
		state ? blockScrollBar('lock') : blockScrollBar('unlock');
	}, [state]);

	const node = document.querySelector('#modal_root');
	if (!node) return null;

	return (
		createPortal(
			<>
				<Backdrop open={state} onClose={onClose} bgStyle={bgStyle}/>
				<CSSTransition
					in={state}
					timeout={300}
					classNames={classNames}
					nodeRef={popupRef}
					mountOnEnter
					unmountOnExit
					appear
				>
					<div
						className={styles.popup}
						ref={popupRef}
						onClick={(e) => e.stopPropagation()}
					>
						{children}
					</div>
				</CSSTransition>
			</>,
		node)
	);
}
